/** Convert short filing path to full SEC URL */
export function filingPathToUrl(path: string): string {
  return `https://www.sec.gov/Archives/edgar/data/${path}`;
}

/**
 * Normalize SEC URL to direct filing URL.
 * Converts iXBRL viewer URLs (/ix?doc=...) to direct filing URLs.
 */
export function normalizeSecUrl(url: string): string {
  const ixMatch = url.match(/sec\.gov\/ix\?doc=([^&]+)/);
  if (ixMatch) {
    const docPath = decodeURIComponent(ixMatch[1]);
    return `https://www.sec.gov${docPath}`;
  }
  return url;
}

/** Extract filing path from full SEC URL */
export function urlToFilingPath(url: string): string | null {
  const normalizedUrl = normalizeSecUrl(url);
  const match = normalizedUrl.match(/sec\.gov\/Archives\/edgar\/data\/(.+)$/);
  return match ? match[1] : null;
}
